import { render, staticRenderFns } from "./CreatorRequestDisputeStatus.vue?vue&type=template&id=183eb54a&"
import script from "./CreatorRequestDisputeStatus.vue?vue&type=script&lang=js&"
export * from "./CreatorRequestDisputeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports